import { createSlice } from '@reduxjs/toolkit';
import { FILTER_VALUES } from '../../constants/FilterConstants';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

const initialState = {
  RepPay: {
    [FILTER_VALUES.INDEPENDENTREP]: [],
    [FILTER_VALUES.SUBLOCATION]: [],
    searchText: '',
    pageNumber: DEFAULT_PAGE,
    rowsPerPage: DEFAULT_PER_PAGE,
  },
};

export const repPayFilterSlice = createSlice({
  name: 'repPayFilter',
  initialState,
  reducers: {
    setIReUsersFilters(state, action) {
      state.RepPay[FILTER_VALUES.INDEPENDENTREP] = action.payload?.independentRepId || [];
      state.RepPay[FILTER_VALUES.SUBLOCATION] = action.payload?.subLocationId || [];
      state.RepPay.searchText = action.payload?.searchText || '';
      state.RepPay.pageNumber = action.payload?.pageNumber || DEFAULT_PAGE;
      state.RepPay.rowsPerPage = action.payload?.rowsPerPage || DEFAULT_PER_PAGE;
    },
    resetIRUsersFiltersState(state) {
      state.RepPay = {
        ...initialState.RepPay,
        searchText: state.RepPay.searchText,
      };
    },
    resetState(state) {
      Object.assign(state, initialState);
    },
  },
});

export default repPayFilterSlice;
